import moment from 'moment';

import {
  SET_IS_LOADING,
  SET_SCHEDULING_SERVICES,
  CLEAR_SCHEDULING_SERVICES
} from './constants';

const defaultState = {
  isLoading: false,
  submit: {
    id: '',
    situationId: 1,
    recurrenceId: '',
    typeId: 2,
    services: [],
    dateStart: moment(moment.now()).format('YYYY-MM-DD'),
    timeStart: '',
    dateEnd: moment(moment.now()).format('YYYY-MM-DD'),
    timeEnd: '',
    completeAddress: '',
    clientId: '',
    discount: {
      type: '1',
      amount: ''
    },
    delivery: {
      addressType: 'others',
      address: ''
    },
    recurrence: {
      frequencyId: '',
      endDate: moment(moment.now()).format('YYYY-MM-DD')
    },
    vehicle: {
      plate: '',
      vehicleColor: '',
      vehicleModel: ''
    },
    client: {
      name: '',
      phone: '',
      email: '',
      address: ''
    }
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action?.isLoading
      }
    }
    case SET_SCHEDULING_SERVICES: {
      const {
        id,
        situationId,
        recurrenceId,
        observation,
        services,
        startDateTime,
        endDateTime,
        completeAddress,
        discount,
        recurrence,
        client,
        vehicle
      } = action.data || {};

      const getAddressType = (clientId, completeAddress) => {
        if(!!clientId && !!completeAddress) {
          return 'address';
        }

        if(!clientId && !!completeAddress) {
          return 'others';
        }

        return 'others';
      }

      return {
        ...state,
        submit: {
          id,
          situationId: +situationId,
          recurrenceId,
          observation,
          services,
          dateStart: startDateTime?.split(' ')[0],
          timeStart: startDateTime?.split(' ')[1]?.substring(0, 5),
          dateEnd: endDateTime?.split(' ')[0],
          timeEnd: endDateTime?.split(' ')[1]?.substring(0, 5),
          completeAddress,
          clientId: client?.clientId,
          discount: {
            amount: (discount?.typeId == 2) ? parseInt(discount?.amount, 10) : discount?.amount,
            type: discount?.typeId
          },
          client: {
            name: client?.name,
            email: client?.email,
            phone: (!!client?.phones && JSON.parse(client?.phones)?.length > 0) ? JSON.parse(client?.phones)[0] : '',
            address: completeAddress || ''
          },
          delivery: {
            addressType: getAddressType(client?.clientId, completeAddress),
            address: completeAddress || ''
          },
          recurrence: {
            frequencyId: recurrence?.frequencyId,
            endDate: recurrence?.endDate
          },
          vehicle: {
            plate: vehicle?.plate,
            vehicleColor: vehicle?.vehicleColor,
            vehicleModel: vehicle?.vehicleModel
          }
        }
      }
    }
    case CLEAR_SCHEDULING_SERVICES: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}